module.exports = __webpack_public_path__ + "img/the-national-gambling-helpline-colour.0d6619f8.svg";